import React from 'react';
import { IconBase } from '../Base';
export const IconListAdd = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
            React.createElement("path", { d: "M6.66669 3.33337H16.6667" }),
            React.createElement("path", { d: "M2.5 3.33337H3.33333" }),
            React.createElement("path", { d: "M2.5 6.66675H3.33333" }),
            React.createElement("path", { d: "M2.5 10H3.33333" }),
            React.createElement("path", { d: "M6.66669 6.66675H16.6667" }),
            React.createElement("path", { d: "M6.66669 10H8.33335" }),
            React.createElement("path", { d: "M14.1667 17.5001C13.0616 17.5001 12.0018 17.0611 11.2204 16.2797C10.439 15.4983 10 14.4385 10 13.3334C10 11.0801 11.9167 9.16425 14.17 9.16675C15.2751 9.16719 16.3347 9.6066 17.1158 10.3883C17.8969 11.17 18.3354 12.23 18.335 13.3351C18.3346 14.4402 17.8951 15.4998 17.1134 16.2809C16.3317 17.062 15.2717 17.5005 14.1667 17.5001Z" }),
            React.createElement("path", { d: "M14.1667 11.6667V15.0001" }),
            React.createElement("path", { d: "M15.8333 13.3334H12.5" }))));
};
//# sourceMappingURL=ListAdd.js.map